import request from '@/utils/request';
const baseURL = '/api/posclient/';

//取得系統版號
export function version() {
  return request({
    loading: false,
    method: 'get',
    url: `${baseURL}application/version`,
  });
}

//確認硬體狀態
export function checkDeviceStatus() {
  return request({
    method: 'get',
    url: `${baseURL}checkDeviceStatus`,
  });
}

//取得來源類型支付等permission
export function applicationInfo() {
  return request({
    method: 'get',
    url: `${baseURL}application/info`,
  });
}

//取得一些系統運行的參數
export function applicationConfig() {
  return request({
    method: 'get',
    url: `${baseURL}application/posConfig`,
  });
}

//取得各式數量
export function echo() {
  return request({
    loading: false,
    method: 'get',
    url: `${baseURL}echo`,
  });
}
//取得班號
export function getDutySection() {
  return request({
    loading: false,
    method: 'get',
    url: `${baseURL}user/getDutySection`,
  });
}

//登入
export function userLogin(data) {
  return request({
    method: 'post',
    url: `${baseURL}user/login`,
    data,
  });
}
//登出
export function userLogout() {
  return request({
    method: 'get',
    url: `${baseURL}user/logout`,
  });
}

//重開機
export function reboot(data) {
  return request({
    method: 'post',
    url: `${baseURL}reboot`,
    data,
  });
}

//關機
export function shutdown(data) {
  return request({
    method: 'post',
    url: `${baseURL}shutdown`,
    data,
  });
}

//取得一次性token
export function verify(data) {
  return request({
    method: 'post',
    url: `${baseURL}user/verify`,
    data,
  });
}

//開錢櫃
export function openCashBox() {
  return request({
    loading: false,
    method: 'get',
    url: `${baseURL}openCashBox`,
  });
}

//訊息相關--------------------------------------------------
//取得訊息總覽
export function notificationSummary() {
  return request({
    method: 'get',
    url: `${baseURL}notification/summary`,
  });
}
//取得訊息列表
export function notificationList(data) {
  return request({
    method: 'post',
    url: `${baseURL}notification/list`,
    data,
  });
}
//讀取訊息內容
export function notificationRead(id) {
  return request({
    method: 'get',
    url: `${baseURL}notification/read?id=${id}`,
  });
}

//裝置相關--------------------------------------------------
//取得裝置列表
export function deviceList() {
  return request({
    method: 'get',
    url: `${baseURL}device/list`,
  });
}
//儲存裝置設定
export function deviceSave(data) {
  return request({
    method: 'post',
    url: `${baseURL}device/save`,
    data,
  });
}

//商品資料相關--------------------------------------------------
//商品資料更新
export function updatePosData(data) {
  return request({
    method: 'post',
    url: `${baseURL}updatePosData`,
    data,
  });
}

//商品資料更新狀態確認
export function getUpdatePosDataStatus() {
  return request({
    method: 'get',
    url: `${baseURL}getUpdatePosDataStatus`,
  });
}
